// グローバルなfetchインターセプター
const originalFetch = window.fetch;

window.fetch = async function(...args) {
  const [resource, config] = args;
  
  try {
    const response = await originalFetch(resource, config);
    
    // 401エラーの処理
    if (response.status === 401) {
      // localStorageのユーザー情報をクリア
      localStorage.removeItem('user');
      
      // ログインページへリダイレクト
      // React RouterのuseNavigateは使えないため、window.locationを使用
      // ベースURLに対応
      const loginPath = window.location.origin + '/auth';
      if (window.location.pathname !== '/auth') {
        window.location.href = loginPath;
      }
    }
    
    return response;
  } catch (error) {
    throw error;
  }
};

export {};